import { initializeApp } from 'firebase/app';
import { getPerformance } from 'firebase/performance';
import FirebaseConfig from './Firebase.json';

let firebase = initializeApp(FirebaseConfig);
let perf = getPerformance(firebase);

export default firebase;